var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-secondary my-2"},[_c('b-spinner',{staticClass:"align-middle"}),_vm._v(" "),_vm._t("body",function(){return [_c('strong',[_vm._v("Loading...")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }